// Libs
import React, { useContext } from 'react'
import styled from 'styled-components'

// Comps
import { show, showFinally } from '../../../utils'
import { EventHookInterface } from '../../../types'
import { BookButton } from './BookButton'
import { EmailRSVPButton } from './EmailRSVPButton'
import { UserContext, StripeContext, GroupContext } from '../../../context'
import { PaidEventSummary } from './PaidEventSummary'

// Styles
const Container = styled.div`
  justify-content: flex-start;
  margin-top: 30px;
  row-gap: 16px;
  display: flex;
  flex-direction: column;
`

// Props.
interface Props {
  eventHook: EventHookInterface
  handleNotGoing: () => void
}

export const BookAndShare: React.FC<Props> = ({
  eventHook,
  handleNotGoing,
}) => {
  // Global State
  const { currentUser, loaded } = useContext(UserContext)
  const { isEditable } = eventHook

  // short circuit and display nothing when editing
  if (isEditable) return null
  // ..
  return (
    <Container className="bookField">
      {/* Book Button. */}
      {/* Button for Full users */}
      {show(
        loaded && currentUser !== null && eventHook.value?.id !== undefined,
      ) && (
        <>
          <BookButton eventHook={eventHook} handleNotGoing={handleNotGoing} />
          <PaidEventSummary event={eventHook.value} />
        </>
      )}

      {/* Button for RSVP users */}
      {show(
        loaded && currentUser === null && eventHook.value?.id !== undefined,
      ) && (
        <>
          <EmailRSVPButton
            eventHook={eventHook}
            handleNotGoing={handleNotGoing}
          />
        </>
      )}

      {/* WaitingListButton is here for debug - ordinarily it is a child of BookButton */}
      {/* <WaitingListButton eventHook={eventHook} /> */}

      {/* Share Button. - Disabled pre Waiting List */}
      {/* <ShareButton eventHook={eventHook}/> */}
    </Container>
  )
}
